import { Banner } from "components/DesignSystem/Banner/Banner";
import { Button } from "components/DesignSystem/Button/Button";
import { useChannelEscalationStatus } from "hooks/useChannelEscalationStatus";
import { useToast } from "hooks/useToast";
import {
  HUMAN_SUPPORT_STATUS,
  useJoinHumanSupportMutation,
} from "store/apis/chatHumanSupport";
import { BackendError } from "types/utils/error";

export const JoinHumanSupport = () => {
  const { alertToast } = useToast();
  const { channelId, escalationStatus } = useChannelEscalationStatus();
  const [joinHumanSupport, { isLoading: isJoiningHumanSupport }] =
    useJoinHumanSupportMutation();

  const handleJoinHumanSupport = async () => {
    try {
      await joinHumanSupport({ channelId }).unwrap();
    } catch (err) {
      alertToast({
        message:
          (err as BackendError).data?.error?.message ?? "Something went wrong",
      });
    }
  };

  if (escalationStatus === HUMAN_SUPPORT_STATUS.PENDING) {
    return (
      <div className="t-mx-4 t-mb-2">
        <Banner
          type="warning"
          title="Human assistance requested"
          description={
            "Join to assist — the customer will be notified and this chat assigned to you."
          }
          cta={
            <Button
              type="button"
              customType="primary"
              size="small"
              isLoading={isJoiningHumanSupport}
              onClick={handleJoinHumanSupport}
            >
              Join
            </Button>
          }
        />
      </div>
    );
  }
  return null;
};
